import { render, staticRenderFns } from "./RemoverSaldoModal.vue?vue&type=template&id=b0995396&scoped=true"
import script from "./RemoverSaldoModal.vue?vue&type=script&lang=js"
export * from "./RemoverSaldoModal.vue?vue&type=script&lang=js"
import style0 from "./cashbackModal.css?vue&type=style&index=0&id=b0995396&prod&scoped=true&lang=css&external"
import style1 from "./cashbackModalCaixa.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0995396",
  null
  
)

export default component.exports